import RmSetDriverVehicleinfoModal from './rm-set-driver-vehicleinfo-modal.vue'
export default RmSetDriverVehicleinfoModal
